import React from "react";
import "./App.css";
import Main from "./Pages/Main/Main";
import { useParams, useLocation } from "react-router-dom";
import { MainModel } from "./Classes/MainModel";
import "reflect-metadata";

function App() {
  const { campaignId } = useParams();

  const raw = window.location.search.replace(/^\?/, "");
  const first = raw.split("&")[0] || ""; // first chunk after '?'

  const guidRe =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  const codeRe = /^[0-9A-Za-z]{6}$/;

  let candidateId = null;

  if (
    (first.toLowerCase().startsWith("fbclid=") ||
      first.toLowerCase().startsWith("fblid=")) == false
  ) {
    // candidate token can be "2AABba=" or a GUID or URL-encoded
    const token = decodeURIComponent(first).replace(/=+$/, "").trim();

    if (guidRe.test(token) || codeRe.test(token)) {
      candidateId = token;
    }
  }

  let mainModel = new MainModel(campaignId);
  if (candidateId) {
    mainModel.CandidateId = candidateId;
  }

  return (
    <div className="full-container">
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH"
        crossOrigin="anonymous"
      ></link>
      <script
        src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"
        integrity="sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz"
        crossOrigin="anonymous"
      ></script>
      <Main {...mainModel} />
    </div>
  );
}

export default App;
